import {FC, RefObject} from 'react';
import {OnClickOutsideOptions, useOnClickOutside} from './useOnClickOutside';

export const HandleClickOutside: FC<{
  wrapperRef: RefObject<HTMLDivElement | null>;
  onClose: VoidFunction;
  options?: OnClickOutsideOptions;
}> = ({wrapperRef, onClose, options}) => {
  useOnClickOutside(wrapperRef, onClose, options);
  return null;
};
